import "%js%/common/lazyload.js";
import "%js%/common/scroll-to-block.js";
import "%js%/common/replace-svg-to-inline.js";